export interface ScoreEventHitTarget {
  id: string;
  headIndex?: number;
  /** CSS pixels, so the tap area does not shrink with a responsive score. */
  x: number;
  y: number;
}

/** Overlapping tap areas belong to the nearest head/rest, never SVG paint order.
 * Chord heads may share an id; each head contributes its own reachable area. */
export function nearestScoreHead(
  targets: readonly ScoreEventHitTarget[],
  x: number,
  y: number,
  radius = 22,
): ScoreEventHitTarget | null {
  let nearest: ScoreEventHitTarget | null = null;
  let bestDistance = radius * radius;
  for (const target of targets) {
    const distance = (target.x - x) ** 2 + (target.y - y) ** 2;
    if (distance > bestDistance || (nearest !== null && distance === bestDistance)) continue;
    nearest = target;
    bestDistance = distance;
  }
  return nearest;
}

/** Legacy callers need only the event identity. */
export function nearestScoreEvent(
  targets: readonly ScoreEventHitTarget[],
  x: number,
  y: number,
  radius = 22,
): string | null {
  return nearestScoreHead(targets, x, y, radius)?.id ?? null;
}
